"use client";

import { useStore } from "@/store/store";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useRef, useState } from "react";
import { useClickAway } from "react-use";
import ym from "react-yandex-metrika";

interface SearchProps {
  handleSidebar?: () => void;
  isHamburgerMenuOpen?: boolean;
}

const Search = ({ handleSidebar, isHamburgerMenuOpen }: SearchProps) => {
  const inputRef = useRef(null);
  const path = usePathname();
  const router = useRouter();

  const [isFocused, setIsFocused] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const [searchHistory, setSearchHistory] = useState<string[]>([]);

  const data = useStore((state) => state.data);
  const search = useStore((state) => state.search);
  const setSearch = useStore((state) => state.setSearch);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };
  const handleFocus = () => {
    if (windowWidth < 768 && path === "/" && !isHamburgerMenuOpen) {
      router.push(`/search`);
    }
    setIsFocused(true);

    const storedHistory = localStorage.getItem("searchHistory");
    setSearchHistory(storedHistory ? JSON.parse(storedHistory) : []);
  };

  const ref = useRef(null);
  useClickAway(ref, () => {
    setIsFocused(false);
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const newHistory = [
      search,
      ...searchHistory.filter((item) => item !== search),
    ];
    setSearchHistory(newHistory);
    localStorage.setItem("searchHistory", JSON.stringify(newHistory));
    handleSidebar?.();
    router.push(`/results`);
  };

  const handleSelectQuery = (selectedQuery: string) => {
    setSearch(selectedQuery);
    router.push(`/results`);
  };

  const handleDeleteLsItem = (value: string) => {
    const storedHistory = localStorage.getItem("searchHistory");
    const newHistory = storedHistory ? JSON.parse(storedHistory) : [];
    const temp = newHistory.filter((item: string) => item !== value);
    setSearchHistory(temp);
    localStorage.setItem("searchHistory", JSON.stringify(temp));
  };

  useEffect(() => {
    if (path === "/" || path === "/search") {
      setSearch("");
    }
    const savedHistory = localStorage.getItem("searchHistory");
    if (savedHistory) {
      setSearchHistory(JSON.parse(savedHistory));
    } else {
      setSearchHistory([]);
    }
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return (
    <>
      <div className='relative min-w-[230px] sm:w-full sm:max-w-[790px] z-20'>
        <form
          onSubmit={(e) => handleSubmit(e)}
          className={`${
            (path === "/catalogue" && !isHamburgerMenuOpen) ||
            (path === "/discounts" && !isHamburgerMenuOpen)
              ? "min-w-[230px] min-h-[32px]"
              : "min-w-[335px] min-h-[52px]"
          }   flex  items-center justify-between sm:min-h-[52px]  w-full sm:max-w-[790px]`}
        >
          <div
            ref={ref}
            className={`${
              (path === "/catalogue" && !isHamburgerMenuOpen) ||
              (path === "/discounts" && !isHamburgerMenuOpen)
                ? "min-h-[32px] "
                : " min-h-[52px]"
            }  flex flex-1 flex-row items-center sm:h-[52px]  bg-white rounded-[12px] sm:rounded-[16px] px-2 lg:px-[16px] border border-[#D3D5DC] `}
          >
            <Image
              className='w-4 h-4'
              src={"/ui/searchIcon.svg"}
              width={16}
              height={16}
              alt='Search'
            />
            <input
              ref={inputRef}
              className='flex flex-1 items-center bg-no-repeat border-none px-[4px]  md:px-[8px] lg:px-[12px] py-[2px] sm:py-[12px]  text-gray-950 focus:ring-0 focus:outline-none focus:border-none '
              type='search'
              name='content'
              placeholder='Найти кроссовки'
              value={search}
              onChange={handleSearch}
              onFocus={handleFocus}
            />
          </div>
        </form>
        {isFocused && path !== "/search" && (
          <div
            ref={ref}
            className='z-100 hidden sm:flex flex-col absolute bg-white w-[263px] sm:w-[790px] rounded-[24px] mt-[4px] shadow-md text-black '
          >
            <div className='p-3 gap-4'>
              <div>
                {searchHistory.length > 0 && (
                  <h1 className='text-xl font-bold'>История</h1>
                )}

                <ul className='flex flex-col gap-1'>
                  {searchHistory.slice(0, 5).map((item, index) => (
                    <li
                      className='group flex flex-row gap-1 hover:bg-[#F6F6F6] hover:cursor-pointer rounded-[10px] p-1 px-2 justify-between'
                      key={index}
                    >
                      <div className='flex flex-row gap-1 items-center'>
                        <Image
                          src={"/ui/timer.svg"}
                          width={24}
                          height={24}
                          alt='Timer'
                        />
                        <p
                          className=' text-[#6C6C6C] text-[17px] '
                          onClick={() => {
                            handleSelectQuery(item);
                            ym("reachGoal", "main_searching_bar_history_item");
                          }}
                        >
                          {item}
                        </p>
                      </div>
                      <Image
                        className='group-hover:block hidden'
                        onClick={() => handleDeleteLsItem(item)}
                        src={"/ui/closeIcon.svg"}
                        width={10}
                        height={10}
                        alt='Delete'
                      />
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h1 className='text-xl font-bold'>Часто ищут</h1>
                <ul className='flex flex-col p-2 gap-2'>
                  {data.slice(0, 5).map((res, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        router.push(`/product/${res.id}`);
                        ym(
                          "reachGoal",
                          "main_searching_bar_recomendation_item"
                        );
                      }}
                      className='text-black p-1 items-center flex-row flex justify-between hover:bg-[#F6F6F6] hover:cursor-pointer rounded-[10px]'
                    >
                      <div className='flex flex-row w-full gap-2 j items-center'>
                        <div className='rounded-[10px]'>
                          <Image
                            className='rounded-[10px]'
                            src={res.images}
                            width={61}
                            height={61}
                            alt='Sneaker'
                          />
                        </div>

                        <h2 className='text-sm sm:text-[17px] font-bold max-w-[400px]'>
                          {res.title}
                        </h2>
                      </div>
                      <div className='flex flex-col'>
                        <p className='text-sm sm:text-[17px] font-extrabold min-w-20 text-nowrap'>
                          от {res.price}
                        </p>
                        <p className='text-xs '>
                          в {res.shops?.length} магазинах
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Search;
